<template>
  <com-page>
    <com-card>
      <el-descriptions title="订单信息" :column="4">
        <el-descriptions-item label="超时订单号">{{ detail.code }}</el-descriptions-item>
        <el-descriptions-item label="网点名称"></el-descriptions-item>
        <el-descriptions-item label="设备号">{{ detail.refDevSn }}</el-descriptions-item>
        <el-descriptions-item label="设备二维码">{{ detail.refDevLabel }}</el-descriptions-item>
        <el-descriptions-item label="设备类型">{{ deviceTypeMap[detail.deviceType] }}</el-descriptions-item>
        <el-descriptions-item label="端口">{{ detail.port }}</el-descriptions-item>
        <el-descriptions-item label="超时开始时间">{{ detail.startTime }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ detail.endTime }}</el-descriptions-item>
        <el-descriptions-item label="超时时长">{{ detail.timeoutDuration }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ orderStatus[detail.status] }}</el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-button type="text" style="padding: 2px 7px" @click="openFeeStandardDialog">查看</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="订单小计（元）">{{ detail.sum }}</el-descriptions-item>
        <el-descriptions-item label="实付金额（元）">{{ detail.paySum }}</el-descriptions-item>
        <el-descriptions-item label="支付方式">{{ payTypeMap[detail.payType]}}</el-descriptions-item>
        <el-descriptions-item label="充电订单">{{ detail.refChargePieOrderNumber }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ detail.refXdUserNumber }}</el-descriptions-item>
        <el-descriptions-item label="用户手机号">{{ detail.refXdUserPhone }}</el-descriptions-item>
      </el-descriptions>
    </com-card>

    <TimeoutOrderFeeStandards ref="feeStandardDialogRef" />
  </com-page>
</template>

<script>
import { timeoutOccupancyDetail } from '@/api/order'

import TimeoutOrderFeeStandards from './components/timeout-order-fee-standards'

export default {
  components: { TimeoutOrderFeeStandards },
  data() {
    return {
      code: '',
      detail: {},
      orderStatus: {
        1: '进行中',
        2: '已完成',
      },
      deviceTypeMap: {
        1: '电动车充电桩',
        2: '充电柜',
        3: '汽车充电桩'
      },
      payTypeMap: {
        1: '钱包支付'
      }
    }
  },
  created() {
    this.code = this.$route.query.code

    this.getDetail()
  },
  methods: {
    getDetail() {
      timeoutOccupancyDetail({ code: this.code }).then(res => {
        this.detail = res.data.result
      })
    },

    openFeeStandardDialog() {
      this.$refs.feeStandardDialogRef.open(this.detail.chargePlanBean)
    },
  },
}
</script>

<style lang="scss" scoped></style>
